<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="transactionsFiltered"
	[loading]="!transactionsFiltered"
	[globalFilterFields]="app.keys(transactionsFiltered)"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="transactionDateTime">
				<div class="d-flex justify-content-between">
					<div>Date</div>
					<div>
						<p-columnFilter type="date" field="transactionDateTime" display="menu"></p-columnFilter>
						<p-sortIcon field="transactionDateTime"></p-sortIcon>
					</div>
				</div>
			</th>
			<th pSortableColumn="value">
				<div class="d-flex justify-content-between">
					<div>Value</div>
					<div>
						<p-sortIcon field="displayName"></p-sortIcon>
					</div>
				</div>
			</th>
			<th pSortableColumn="transactionAmount">
				<div class="d-flex justify-content-between">
					<div>Purchase Price</div>
					<div>
						<p-sortIcon field="transactionAmount"></p-sortIcon>
					</div>
				</div>
			</th>
			<th pSortableColumn="purchaserLastName">
				<div class="d-flex justify-content-between">
					<div>Purchaser</div>
					<div>
						<p-sortIcon field="purchaserLastName"></p-sortIcon>
					</div>
				</div>
			</th>
			<th pSortableColumn="recipientName">
				<div class="d-flex justify-content-between">
					<div>Recipient</div>
					<div>
						<p-sortIcon field="recipientName"></p-sortIcon>
					</div>
				</div>
			</th>
			<th pSortableColumn="activated">
				<div class="d-flex justify-content-between">
					<div>Activated</div>
					<div>
						<p-sortIcon field="activated"></p-sortIcon>
					</div>
				</div>
			</th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td (click)="transactionInfo(rec)">
				<div>
					{{ moment(rec.transactionDateTime).format("l LT") }}
				</div>
			</td>
			<td (click)="transactionInfo(rec)">
				{{ rec.value | currency }}
			</td>
			<td (click)="transactionInfo(rec)">
				{{ rec.transactionAmount | currency }}
			</td>
			<td (click)="transactionInfo(rec)">
				<div class="d-flex flex-column">
					<div>{{ rec.purchaserLastName }}, {{ rec.purchaserFirstName }}</div>
					<div class="overflow-scroll">{{ rec.purchaserEmail }}</div>
				</div>
			</td>
			<td (click)="transactionInfo(rec)">
				<div class="d-flex flex-column">
					<div *ngIf="!rec.recipientLastName">
						{{ rec.recipientName }}
					</div>
					<div *ngIf="rec.recipientLastName">{{ rec.recipientLastName }}, {{ rec.recipientFirstName }}</div>
					<div class="overflow-scroll">
						{{ rec.recipientEmail }}
					</div>
				</div>
			</td>
			<td (click)="transactionInfo(rec)">
				<fa-icon *ngIf="rec.activated" [icon]="['far', 'check']"></fa-icon>
			</td>
			<td>
				<p-button
					pRipple
					styleClass="p-button-raised p-button-warning m-2"
					(click)="resend(rec)"
					pTooltip="Resend EGift Email"
					[disabled]="rec.activated"
				>
					<ng-template pTemplate="content">
						<fa-icon [icon]="['far', 'paper-plane']" size="lg" class="ms-1"></fa-icon>
					</ng-template>
				</p-button>
			</td>
		</tr>
	</ng-template>
</p-table>

<p-dialog
	*ngIf="transactionSelected"
	[(visible)]="transactionSelected"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
	[closable]="true"
>
	<ng-template pTemplate="header">
		<div class="d-flex">
			<fa-icon [icon]="['far', 'gift-card']" class="me-4" size="2x"></fa-icon>
			<div class="display-8 ms-1 my-auto">Gift Card</div>
		</div>
		<p-divider></p-divider>
	</ng-template>
	<app-e-gift-transaction-record
		#transactionRecord
		[adHocTransaction]="adHocTransaction"
		[transactionSelected]="transactionSelected"
		(transactionEmitter)="adhocTransactionSubmit($event)"
		(editTransactionEmitter)="returnFromEditTransaction($event)"
	></app-e-gift-transaction-record>

	<ng-template pTemplate="footer">
		<div class="d-flex w-100">
			<div class="d-flex ms-auto">
				<p-button
					*ngIf="!adHocTransaction"
					pRipple
					styleClass="p-button-raised p-button-primary m-2"
					(click)="transactionRecord.initEditTransaction()"
					[disabled]="transactionRecord.editTransaction || transactionRecord.transactionSelected.activated"
				>
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1 me-2"></fa-icon>
							Edit
						</div>
					</ng-template>
				</p-button>
				<p-button
					*ngIf="adHocTransaction"
					pRipple
					styleClass="p-button-raised p-button-success m-2"
					(click)="transactionRecord.saveAction()"
					[disabled]="
						adHocTransaction &&
						!transactionRecord.transactionSelected.recipientName &&
						!transactionRecord.transactionSelected.recipientEmail &&
						!transactionRecord.transactionSelected.value
					"
				>
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1 me-2"></fa-icon>
							Save
						</div>
					</ng-template>
				</p-button>
				<app-record-control-footer
					[hideCancel]=""
					[hideDelete]="true"
					[hideSave]="adHocTransaction"
					(onCancelChange)="transactionSelected = undefined"
					(onSaveChange)="transactionRecord.saveAction()"
					[cancelDisabled]=""
					[saveDisabled]="
						!transactionRecord.editTransaction || (transactionRecord.editTransaction && !transactionRecord.transactionSelected.recipientEmail)
					"
				></app-record-control-footer>
			</div>
		</div>
	</ng-template>
</p-dialog>
